<template>
  <b-modal v-model="modal" :title="title" size="md" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveLanguage()" autocomplete="off">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="code">Código <span class="text-danger">*</span></label>
                <input
                  id="code"
                  v-model="language.code"
                  name="code"
                  type="text"
                  class="form-control"
                  placeholder="Ex: pt-BR, en-US"
                  :class="{
                    'is-invalid': submitted && $v.language.code.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.language.code.required"
                  class="invalid-feedback"
                >
                  O campo código é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="flag">Bandeira (Emoji)</label>
                <input
                  id="flag"
                  v-model="language.flag"
                  name="flag"
                  type="text"
                  class="form-control"
                  placeholder="Ex: 🇧🇷"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="name">Nome <span class="text-danger">*</span></label>
                <input
                  id="name"
                  v-model="language.name"
                  name="name"
                  type="text"
                  class="form-control"
                  placeholder="Ex: Portuguese (Brazil)"
                  :class="{
                    'is-invalid': submitted && $v.language.name.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.language.name.required"
                  class="invalid-feedback"
                >
                  O campo nome é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="native_name">Nome Nativo <span class="text-danger">*</span></label>
                <input
                  id="native_name"
                  v-model="language.native_name"
                  name="native_name"
                  type="text"
                  class="form-control"
                  placeholder="Ex: Português (Brasil)"
                  :class="{
                    'is-invalid': submitted && $v.language.native_name.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.language.native_name.required"
                  class="invalid-feedback"
                >
                  O campo nome nativo é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="sort_order">Ordem de Exibição</label>
                <input
                  id="sort_order"
                  v-model="language.sort_order"
                  name="sort_order"
                  type="number"
                  class="form-control"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Status</label>
                <div class="mt-2">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="is_active"
                      v-model="language.is_active"
                    />
                    <label class="form-check-label" for="is_active">
                      {{ language.is_active ? 'Ativo' : 'Inativo' }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveLanguage()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  props: {
    idLanguage: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Novo Idioma',
      loading: true,
      fullPage: true,
      submitted: false,
      language: {
        code: '',
        name: '',
        native_name: '',
        flag: '',
        is_active: true,
        sort_order: 0
      },
      modal: false
    }
  },
  validations () {
    return {
      language: {
        code: { required },
        name: { required },
        native_name: { required }
      }
    }
  },
  methods: {
    ...mapActions('language', {
      getLanguage: 'getLanguage',
      postData: 'save'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Idioma'
        this.getLanguage(id).then(() => {
          this.language = { ...this.data }
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveLanguage () {
      this.submitted = true
      this.$v.language.$touch()
      if (this.$v.language.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      await this.postData(this.language).then(() => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.language = {
        code: '',
        name: '',
        native_name: '',
        flag: '',
        is_active: true,
        sort_order: 0
      }
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('language', { data: 'language' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
